export default {
  namespace: "renderKey",
  state: "phone",
  reducers: {
    storage(state, { payload }) {
      return payload;
    },
  },
};
